var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStop({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "31px",
    viewBox: "0 0 32 31",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Stop") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Administration",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Manage-Round/Entries-(1)",
    transform: "translate(-784.000000, -261.000000)",
    fill: "#015597"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(660.146203, 242.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(31.853797, 19.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.089888,8.68 L114.808989,8.68 L114.808989,22.32 L101.089888,22.32 Z M107.949438,0 C99.3438202,0 92.3595506,6.94399994 92.3595506,15.4999999 C92.3595506,24.0559998 99.3438202,30.9999997 107.949438,30.9999997 C116.555056,30.9999997 123.539326,24.0559998 123.539326,15.4999999 C123.539326,6.94399994 116.555056,0 107.949438,0 L107.949438,0 Z M107.949438,28.8884682 C100.523048,28.8884682 94.4775281,22.8778057 94.4775281,15.4942341 C94.4775281,8.11066256 100.523048,2.1 107.949438,2.1 C115.375828,2.1 121.421348,8.11066256 121.421348,15.4942341 C121.421348,22.8778057 115.375828,28.8884682 107.949438,28.8884682 L107.949438,28.8884682 Z",
    id: "Fill-112"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStop);
export default __webpack_public_path__ + "static/media/Stop.7e4676d04f7fe7103c9f6816bdbf0942.svg";
export { ForwardRef as ReactComponent };